import { HomeComponent } from './home.component';
import { NgModule } from '@angular/core';
import { HomeRoutingModule } from './home-routing.module';
import { DashboardViewerModule } from '../../shared/components/dashboard-viewer/dashboard-viewer.component';
import { ReportViewerModule } from '../../shared/components/report-viewer/report-viewer.component';
import { AnalyticViewerModule } from '../../shared/components/analytic-viewer/analytic-viewer.component';
import { CommonModule, DatePipe } from '@angular/common';
import { MainLayoutModule } from '../../layouts/main-layout/main-layout.component';
import { DxPivotGridModule, DxChartModule, DxButtonModule, DxPopupModule,
    DxHtmlEditorModule, DxCheckBoxModule, DxSwitchModule, DxTextBoxModule,
    DxValidationGroupModule, DxValidatorModule} from 'devextreme-angular';

@NgModule({
    imports: [
        CommonModule,
        HomeRoutingModule,
        DashboardViewerModule,
        DxValidationGroupModule,
        DxValidatorModule,
        ReportViewerModule,
        AnalyticViewerModule,
        MainLayoutModule,
        DxPivotGridModule,
        DxChartModule,
        DxButtonModule,
        DxPopupModule,
        DxTextBoxModule,
        DxHtmlEditorModule,
        DxCheckBoxModule,
        DxSwitchModule
    ],
    declarations: [HomeComponent],
    exports: [HomeComponent],
    providers: [DatePipe]

})
export class HomeModule { }
